import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';

const RenameDialog = ({ 
  open, 
  onCancel, 
  onConfirm, 
  newTitle, 
  setNewTitle 
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Rename Topic</DialogTitle>
      <DialogContent>
        <TextField
          margin="normal"
          fullWidth
          variant="outlined"
          value={newTitle}
          onChange={(e) => setNewTitle(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm}>
          Rename
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RenameDialog;
